// extracted by mini-css-extract-plugin
module.exports = {"switchcontainer":"switch_switchcontainer__uIcIO","switch":"switch_switch__3gWv5","slider":"switch_slider__Q_giy"};